/**
 * @项目名称: cardloan
 * @功能名称: vue 打点上报指令
 * @文件名称: directive
 * @Date: 2019/3/8
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import Vue from 'vue'
import IScroll from 'iscroll'
import {realType} from '../helper/utils';

function report(data) {
  if(realType(data) !== 'object')return;
  if (window.xy_bj_reporter){
    return window.xy_bj_reporter.report(data)
  }
}
function getEvents(binding) {
  var events = Object.keys(binding.modifiers)
  if(events.length === 0){
    events = ['click']
  }
  return events
}
// 广告位打点上报转换
function transFrom(obj,event){
  var result = {}
  if(obj.trackAdId && obj.trackAdsId){
    result = {
      cmdid: obj.trackCmdId,
      adsid: obj.trackAdsId,
      adid: obj.trackAdId,
      buttonid: obj.buttonid
    }
    if(obj.buttonid === undefined){
      if(event == 'load'){
        result.buttonid = -1
      }else {
        result.buttonid = 1
      }
    }
    return result
  }else {
    return obj
  }
}
Vue.directive('report',{
  inserted (el,binding) {
    var events = getEvents(binding);
    var key = '_reportData'+events[0]
    el[key] = transFrom(binding.value,events[0])
    events.forEach((event)=>{
      // 非img,iframe dom load事件立即上报
      if(event === 'load' && ['IMG','IFRAME'].indexOf(el.nodeName)===-1){
        report(el[key])
      }else {
        el.addEventListener(event,function() {
          report(el[key])
        })
      }
    })
  },
  update(el, binding){
    var events =  getEvents(binding);
    el['_reportData'+events[0]] = transFrom(binding.value,events[0])
  },
  unbind(el, binding){
    var events =  getEvents(binding);
    el['_reportData'+events[0]] = null
  }
})

/**
 * 页面区块滚动指令
 */
Vue.directive('iscroll', {
  inserted(el, binding) {
    let conf = binding.value || {click:true}
    el.xy_scroll = new IScroll(el, conf);
  },
  componentUpdated(el) {
    el.xy_scroll.refresh();
  },
  unbind(el) {
    el.xy_scroll.destroy();
    el.xy_scroll = null;
  }
})
